// TODO think about isolation feature specific logic inside modules (math included)
export {Action} from 'com/gongxigames/math/core/game/enums/Action';
export {Bonus} from 'com/gongxigames/math/core/game/engine/bonus/Bonus';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';

export type TotalBet = {
    bet: number;
    wager: number;
};

export type Position = {
    reel: number;
    row: number;
    symbolId: number;
};

export enum PayType {
    NONE = 0,
    LINE = 1,
    WAY = 2,
    SCATTER = 3,
    JACKPOT = 4,
    PROGRESSIVE = 5
}

export type Pay = {
    type: number;
    win: number;
    count: number;
    symbolId: number;
    bet: number;
    lineId: number;
    ways: number;
    bonusId: number;
    positions: Position[];
    totalWin: () => number;
    getWinSymbols: () => number[];
    isEmpty: () => boolean;
};

export type Reel = {
    symbols: number[];
    getSymbols(): number[]
};

export type ReelSet = {
    id: number;
    reels: Reel[];
    getReels(): Reel[]; // TODO: check if need it
};

export type SpinData = {
    totalBet: TotalBet;
    reelSetId: number;
    reelPositions: number[];
    symbolIds: number[][];
    pays: Pay[];
    action: Action;
    bonusId: number;
    progressiveId: number;
    getWin: () => number;
};

export type TumbleSpin = SpinData & {
    reelSet: ReelSet;
    getByStepPays: (stepID: number) => Pay[]
    getByStepSymbolIds: (stepID: number) => number[][];
    getByStepDropAmount : (stepID: number) => number[];
    getByStepReelPositions: (stepID: number) => number[];
    getByStepBeforeDropSymbolIds: (stepID: number) => number[][];
    getLastStepSymbolIds: () => number[][];
    getAllPays: () => PayEntries;
}

export type PayEntry =  {
    getKey(): number;
    getValue(): [Pay];
    key: number;
    value: [Pay];
}

export type PayEntries = {
    entries: PayEntry[]
}

export type SimplePickBonusData = {
    getPickedIndices: () => number[];
    getPickedValues: () => number[];
    isFinished: () => boolean;
};